import { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import { Subtitle1 } from '@src/elements/typography/typography'
import { OptionGroup } from '@src/elements/select/option-group'
import { Select } from '@src/elements/select/select'
import { Option } from '@src/elements/select/option'
import { HealthGoal } from '@src/data/goal'
import { Textarea } from '@src/elements/input/textarea'
import AddGoal from '@src/routes/members/components/health-goals/add-goal'
import { Button } from '@src/elements/button/button'

@Component
export default class WizardAddGoal extends AddGoal {

  constructor () {
    super()
  }

  render (h: CreateElement) {
    const predefinedGoals = this.defaultGoals.map((goal: HealthGoal) => {
      return <Option type='single-option' value={goal.key} label={this.$t(`PAGE.MEMBERS.GOALS.${goal.key}`)} selected={this.currentGoal.key === goal.key}
                     select={() => this.setTemplateGoal(goal)} />
    })

    return <div class='add-goal'>
      <Subtitle1 class='title'>{this.$t('PAGE.MEMBERS.GOALS.SET_MEMBER_GOAL')}</Subtitle1>
      <Subtitle1>{this.$t('PAGE.MEMBERS.GOALS.SET_MEMBER_GOAL_DESCRIPTION')}</Subtitle1>
      <Select ref='goalSelect' label={this.$t('PAGE.MEMBERS.GOALS.CHOOSE_GOAL')}
              value={this.currentGoal.isTemplateGoal ? this.$t(`PAGE.MEMBERS.GOALS.${this.currentGoal.key}`) : ''}>
        <OptionGroup>{predefinedGoals}</OptionGroup>
      </Select>
      <Subtitle1>{this.$t('PAGE.MEMBERS.GOALS.SET_CUSTOM_GOAL')}</Subtitle1>
      <Textarea ref='customGoal' value={this.currentGoal.name} label={this.$t('PAGE.MEMBERS.GOALS.CUSTOM_GOAL')} keyup={this.setCustomGoal} />
      <Button type='elevated' ref='saveBtn' label={this.$t('SAVE')} click={this.save}
              icon={this.saveInProgress ? '../img/loader' : ''}
              disabled={this.saveInProgress || (!this.currentGoal.name && !this.currentGoal.key)}/>
    </div>
  }
}
